import { ChefHat, Plus } from 'lucide-react';
import { ONBOARDING_TOUR_TARGETS } from '../../../services/onboardingTourService';

interface EmptyDepartmentsProps {
  onAdd?: () => void;
  canAdd?: boolean;
}

export const EmptyDepartments = ({
  onAdd,
  canAdd = true,
}: EmptyDepartmentsProps) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-12 text-center h-full">
      <ChefHat size={48} className="mx-auto mb-4 text-gray-400" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        No departments yet
      </h3>
      <p className="text-gray-500 mb-6">
        {canAdd
          ? 'Create your first department to start organizing menu items.'
          : 'Departments created for this outlet will appear here once they are added by an authorized user.'}
      </p>
      {canAdd && onAdd ? (
        <button
          type="button"
          onClick={onAdd}
          data-onboarding-tour={
            ONBOARDING_TOUR_TARGETS.departmentsEmptyAddButton
          }
          className="inline-flex items-center gap-2 px-4 py-2 bg-pos-primary text-white rounded-lg hover:bg-pos-secondary transition-colors"
        >
          <Plus size={20} />
          <span>Create Department</span>
        </button>
      ) : null}
    </div>
  );
};
